import { render, staticRenderFns } from "./MainPA.vue?vue&type=template&id=ced1a4e0&scoped=true&"
import script from "./MainPA.vue?vue&type=script&lang=ts&"
export * from "./MainPA.vue?vue&type=script&lang=ts&"
import style0 from "./MainPA.vue?vue&type=style&index=0&id=ced1a4e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ced1a4e0",
  null
  
)

export default component.exports